import { useToast } from "@/components/ui/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";

// NOTE:
// This project uses a lightweight custom toast store (use-toast).
// We render only toasts that are open, and wire the close button to dismiss.
export function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <ToastProvider>
      {toasts
        .filter((t) => t?.open !== false)
        .map(function ({ id, title, description, action, ...props }) {
          return (
            <Toast key={id} {...props}>
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && <ToastDescription>{description}</ToastDescription>}
              </div>
              {action}
              <ToastClose
                type="button"
                aria-label="Fermer"
                onClick={() => dismiss(id)}
              />
            </Toast>
          );
        })}
      <ToastViewport />
    </ToastProvider>
  );
}
